<template>
  <div id="subtest-list">
    <transition name="fade">
      <div class="table-responsive">
        <button class="btn btn-success pull-right" @click="createSubtest()" v-if="!showForm && $store.state.tryout.status != 'PUBLISHED'"><span class="fa fa-plus"></span></button>
        <table class="table table-hover" v-if="!showForm">
          <thead>
            <tr>
              <td>#</td>
              <td>Gambar</td>
              <td>Mata Pelajaran</td>
              <td>Jumlah Soal</td>
              <td>Durasi</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(subtest, index) in $store.state.tryout.subtests" v-bind:key="subtest.id" @dblclick="editSubtest(index)">
              <td>{{ index + 1 }}</td>
              <td><img :src="subtest.subject_picture" class="subject-picture"></td>
              <td>{{ subtest.subject_name }}</td>
              <td>{{ subtest.details.length}}</td>
              <td>{{ subtest.duration}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </transition>
    <app-subtestform v-if="showForm" v-on:completed="showForm = false" :subtest="selectedSubtest"></app-subtestform>
    <hr>
    <button v-if="!showForm" type="button" class="btn btn-success pull-right" @click="$emit('completed')">Selanjutnya</button>
  </div>
</template>
<style>
.subject-picture {
  float: left;
  width: 45px;
  height: 34px;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  overflow: hidden;
  margin: -2px 10px -2px 0;
}
</style>

<script>
import SubtestForm from '@/components/tryout/SubtestForm'

export default {
  name: "subtest-list",
  components: {
    'app-subtestform': SubtestForm
  },
  data: function() {
    return {
      showForm: false,
      selectedSubtest: null
    }
  },
  methods: {
    editSubtest: function(index) {
      this.$store.commit('tryout_select_subtest', index)
      this.showForm = true
    },
    createSubtest: function() {
      this.$store.commit('tryout_reset_selected_subtest')
      this.showForm = true
    }
  }
}
</script>




// WEBPACK FOOTER //
// SubtestList.vue?9d2fa9e2